
const ChosenPlan = ({id,children}) => {
  return id === 2 ? "" : children
}
export default ChosenPlan